export default {
  title: "Campaña"
  , form: {
    descripcion: {
      label: "Descripción"
      , th: "Descripción"
    }
    , descripcionapp: {
      label: "Descripción App"
      , th: "Descripción App"
    }
    , se: {
      label: "SE"
      , th: "SE / STORE ID"
    }
    , payfac: {
      label: "Payfac"
      , th: "PAYFAC"
    }
    , storeid: { label: "Store ID" }
    , vendor: {
      label: "Vendor"
      , th: "Vendor"
    }
    , canales: {
      label: "Canales"
      , th: "Canales"
    }
    , dateres: {
      label: "Límites de proceso"
      , thini: "Fecha Inicio"
      , thend: "Fecha Fin"
    }
    , datelim: { label: "Límites campaña" }
    , cuotasimple: { label: "Cuota Simple" }
    , benefpref: { label: "Benef Pref" }
    , contactpref: { label: "Contact Pref" }
    , fincampanaapp: { label: "Fin de Campaña en APP" }
    , oob: { label: "OOB", th: "OOB" }
  }
  , filters: {
    campana: "Campaña"
    , se: "SE"
    , seller: "Seller"
    , storeid: "Store ID"
    , vendor: "Vendor"
    , dateres: "Límites de proceso"
    , datelim: "Límites campaña"
    , status: "Estatus"
    , oob: "OOB"
  }
  , massupdate: {
    title: "Update Masivo"
    , button: "Update Masivo"
    , minregs: "No se seleccionaron registros para actualizar"
  }
  , errors: {
    BD5005: { text: "Ocurrió un error en el catálogo de Campaña" }
    , WS5005: { text: "Ocurrió un error en el catálogo de Campaña" }
    , JS5005: { text: "Ocurrió un error en el catálogo de Campaña" }
    , CR5005: { text: "Ocurrió un error en el catálogo de Campaña" }
    , MU5005: { text: "Ocurrió un error al tratar de actualizar masivamente campañas" }
    , UK_Campana: { text: "Ya existe un registro con el mismo código para el mismo se" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/campana.js